import React from "react";
export function Footer() {
  return <footer className="w-full bg-ink px-4 pb-32 pt-12 text-center" data-id="element-150" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-3xl" data-id="element-151" data-mp="3ggarzyv0aj71">
        <p className="font-serif text-lg font-bold text-white" data-id="element-152" data-mp="3ghc5e9zhvhrx">Insulin Resistance Nutrition Blueprint™</p>
        <p className="mt-1 text-sm text-white/60" data-id="element-153" data-mp="32m1bayt2r0om">Created by Dr. Henry Wells · © 2026 · All rights reserved.</p>
        <div className="mt-6 space-y-3 text-[12px] leading-relaxed text-white/50" data-id="element-154" data-mp="3uf0nja26gata">
          <p data-id="element-155" data-mp="3ucxsgbm63rhp">
            Insulin Resistance Nutrition Blueprint™ is an educational reference and workflow organization resource for
            appropriately qualified healthcare professionals. It does not replace professional training, individualized clinical
            assessment, current evidence, official prescribing information, or applicable local guidelines.
          </p>
          <p data-id="element-156" data-mp="29xvrqfdrbhqd">It does not independently diagnose insulin resistance, prescribe treatment, or guarantee clinical outcomes.</p>
          <p data-id="element-157" data-mp="2evxbz3mx5n3f">Clinical decisions remain the responsibility of the treating healthcare professional.</p>
        </div>
      </div>
    </footer>;
}